import { Routes, Route } from "react-router-dom";
import { Dashboard } from "../../banking/dashboard";
import { Descriptive } from "../../banking/descriptive";
import { ChatScreen } from "../../banking/chat-screen";
import { Quiz } from "../../banking/quiz";
import {
  ROUTE_CHAT,
  ROUTE_LEARNING_ASSETS,
  ROUTE_AI_ANALYSIS,
  ROUTE_QUIZ,
  ROUTE_DASHBOARD,
  ROUTE_LOGIN,
  ROUTE_AI_GENERATE,
  ROUTE_PROFILE,
  ROUTE_COMPETITIVE_EXAM,
  ROUTE_DESCRIPTIVE,
  ROUTE_MOCK_TEST,
} from "../bankingRoute.js";
import { Login } from "../../banking/login";
import { AiGenerator } from "../../banking/ai-generator";
import { AiAnalysis } from "../../banking/ai-analysis";
import { LearningAssets } from "../../banking/learning-assets";
import { CompetitiveExam } from "../../banking/competitive-exam";
import { Profile } from "../../banking/profile";
import { MockTest } from "../../banking/mock-test";

export const BankingRoutes = () => (
  <Routes>
    <Route path={ROUTE_DASHBOARD} element={<Dashboard />} />
    <Route path={ROUTE_DESCRIPTIVE} element={<Descriptive />} />
    <Route path={ROUTE_CHAT} element={<ChatScreen />} />
    <Route path={ROUTE_QUIZ} element={<Quiz />} />
    <Route path={ROUTE_LOGIN} element={<Login />} />
    <Route path={ROUTE_LEARNING_ASSETS} element={<LearningAssets />} />
    <Route path={ROUTE_AI_GENERATE} element={<AiGenerator />} />
    <Route path={ROUTE_AI_ANALYSIS} element={<AiAnalysis />} />
    <Route path={ROUTE_COMPETITIVE_EXAM} element={<CompetitiveExam />} />
    <Route path={ROUTE_PROFILE} element={<Profile />} />
    <Route path={ROUTE_MOCK_TEST} element={<MockTest />} />
  </Routes>
);
